export default __webpack_public_path__ + "static/store-preview-64806a09bd5230a58611476c16ef6ca1.mp4";